import { render, staticRenderFns } from "./Col3.vue?vue&type=template&id=56dd9d38&scoped=true"
import script from "./Col3.vue?vue&type=script&lang=js"
export * from "./Col3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dd9d38",
  null
  
)

export default component.exports